import ReactDOM from "react-dom/client";
import ReactApp from "./ReactApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<ReactApp />);
